<template>
  <td class="pt-3 pb-3 pl-4 pr-4">
    <slot />
  </td>
</template>
